webpackJsonp([82267189633957],{

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/earth.65009aec.jpg";

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/shark.98467332.jpg";

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bee.a69f8dcf.jpg";

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dinosaur.8913a96c.jpg";

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/rainforest.d366ff1d.jpeg";

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/space-station.8859c227.jpg";

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  border-radius: 30px;\n  background-color: #ccc;\n  max-width: 100%;\n  height: 250px;\n  width: auto;\n  margin: 0px auto 20px;\n  display: block;\n  box-shadow: 3px 7px 14px #666;\n"], ["\n  border-radius: 30px;\n  background-color: #ccc;\n  max-width: 100%;\n  height: 250px;\n  width: auto;\n  margin: 0px auto 20px;\n  display: block;\n  box-shadow: 3px 7px 14px #666;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  line-height: 0em;\n  font-size: 30px;\n  margin-top: 40px;\n"], ["\n  text-align: center;\n  line-height: 0em;\n  font-size: 30px;\n  margin-top: 40px;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  text-decoration: none;\n"], ["\n  text-decoration: none;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImage = __webpack_require__(57);
	
	var _reactImage2 = _interopRequireDefault(_reactImage);
	
	var _bee = __webpack_require__(133);
	
	var _bee2 = _interopRequireDefault(_bee);
	
	var _earth = __webpack_require__(59);
	
	var _earth2 = _interopRequireDefault(_earth);
	
	var _spaceStation = __webpack_require__(135);
	
	var _spaceStation2 = _interopRequireDefault(_spaceStation);
	
	var _rainforest = __webpack_require__(134);
	
	var _rainforest2 = _interopRequireDefault(_rainforest);
	
	var _shark = __webpack_require__(60);
	
	var _shark2 = _interopRequireDefault(_shark);
	
	var _dinosaur = __webpack_require__(61);
	
	var _dinosaur2 = _interopRequireDefault(_dinosaur);
	
	var _styledComponents = __webpack_require__(14);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var FlyerImage = (0, _styledComponents2.default)(_reactImage2.default)(_templateObject);
	
	var H5 = _styledComponents2.default.h5(_templateObject2);
	
	var FlyerLink = _styledComponents2.default.a(_templateObject3);
	
	var SchoolsPage = function SchoolsPage() {
		return _react2.default.createElement(
			"div",
			null,
			_react2.default.createElement(
				_reactHelmet2.default,
				null,
				_react2.default.createElement(
					"title",
					null,
					"Virtual and Live Science Roadshows for schools by Lee Ognibene"
				),
				_react2.default.createElement("meta", {
					name: "description",
					content: "Live programs presented for your School or Library by teacher Lee Ognibene."
				})
			),
			_react2.default.createElement(
				"h2",
				null,
				"Shows for Schools"
			),
			_react2.default.createElement(
				"p",
				null,
				"Click below to read more about each show and print out a description to share with your colleagues:"
			),
			_react2.default.createElement(
				"div",
				{ className: "row" },
				_react2.default.createElement(
					"div",
					{ className: "six columns" },
					_react2.default.createElement(
						FlyerLink,
						{ href: "/bug-roadshow" },
						_react2.default.createElement(
							H5,
							null,
							"The Bug Roadshow"
						),
						_react2.default.createElement(FlyerImage, { src: _bee2.default, alt: "Bee" })
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "six columns" },
					_react2.default.createElement(
						FlyerLink,
						{ href: "/space-roadshow" },
						_react2.default.createElement(
							H5,
							null,
							"Space Roadshow"
						),
						_react2.default.createElement(FlyerImage, { src: _spaceStation2.default, alt: "Earth" })
					)
				)
			),
			_react2.default.createElement(
				"div",
				{ className: "row" },
				_react2.default.createElement(
					"div",
					{ className: "six columns" },
					_react2.default.createElement(
						FlyerLink,
						{ href: "/dinosaurs" },
						_react2.default.createElement(
							H5,
							null,
							"Dinosaurs"
						),
						_react2.default.createElement(FlyerImage, { src: _dinosaur2.default, alt: "Dinosaur" })
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "six columns" },
					_react2.default.createElement(
						FlyerLink,
						{ href: "/endangered-earth" },
						_react2.default.createElement(
							H5,
							null,
							"Our Endangered Earth"
						),
						_react2.default.createElement(FlyerImage, { src: _earth2.default, alt: "Earth" })
					)
				)
			),
			_react2.default.createElement(
				"div",
				{ className: "row" },
				_react2.default.createElement(
					"div",
					{ className: "six columns" },
					_react2.default.createElement(
						FlyerLink,
						{ href: "/rainforest-adventure" },
						_react2.default.createElement(
							H5,
							null,
							"Rainforest Adventure"
						),
						_react2.default.createElement(FlyerImage, { src: _rainforest2.default, alt: "Bee" })
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "six columns" },
					_react2.default.createElement(
						FlyerLink,
						{ href: "/under-the-sea" },
						_react2.default.createElement(
							H5,
							null,
							"Under The Sea"
						),
						_react2.default.createElement(FlyerImage, { src: _shark2.default, alt: "Bee" })
					)
				)
			)
		);
	};
	
	exports.default = SchoolsPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-schools-js-58402edebfc6de0e8ed6.js